import {UserTracker} from "../index.js";

const eventDics = {
    "personal-shortcut-click": "shortcut:personal-shortcut-click:click", // 유저 바로가기 클릭
    "intt-shortcut-click": "shortcut:intt-shortcut-click:click", // 회사 바로가기 클릭
    "portal-shortcut-click": "shortcut:portal-shortcut-click:click", // 포탈 바로가기 클릭
    "sample-shortcut-click": "shortcut:sample-shortcut-click:click", // 추천 바로가기 클릭
    "personal-shortcut-add": "shortcut:personal-shortcut-add:click", // 유저 바로가기 추가
    "personal-shortcut-update": "shortcut:personal-shortcut-update:click", // 유저 바로가기 수정
    "personal-shortcut-delete": "shortcut:personal-shortcut-delete:click", // 유저 바로가기 삭제
    "intt-shortcut-add": "shortcut:intt-shortcut-add:click", // 회사 바로가기 추가
    "intt-shortcut-update": "shortcut:intt-shortcut-update:click", // 회사 바로가기 수정
    "intt-shortcut-delete": "shortcut:intt-shortcut-delete:click", // 회사 바로가기 삭제
    "intt-shortcut-display-update": "shortcut:intt-shortcut-display-update:click", // 회사 바로가기 활성화/비활성화
}

export const ShortcutTracker = () => {
    const Tracker = Object.create(UserTracker)
    Tracker.track = (eventName, value = null) => {
        const event = eventDics[eventName];
        if (!event) return;

        return Tracker.trackAction({event: event, value, data: {}});
    }

    return Tracker;
}
